// Board and user management API вЂ” REST endpoints defined as proto services.
// This file adds the CRUD layer that was previously hand-rolled in
// handlers_boards.go and handlers_users.go.
//
// The service definitions use google.api annotations so that buf can
// generate a gRPC-Gateway reverse proxy or OpenAPI spec from the same
// source. Phase 1 deploys the existing chi handlers; Phase 2 wires
// generated gRPC stubs as the primary transport.

// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file gocanvas/v1/api.proto (package gocanvas.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gocanvas/v1/api.proto.
 */
export const file_gocanvas_v1_api: GenFile = /*@__PURE__*/
  fileDesc("ChVnb2NhbnZhcy92MS9hcGkucHJvdG8SC2dvY2FudmFzLnYxIp0CCgVCb2FyZBIKCgJpZBgBIAEoDBIMCgRuYW1lGAIgASgJEhAKCG93bmVyX2lkGAMgASgMEg8KB3ZlcnNpb24YBCABKAMSLgoKY3JlYXRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASMgoIbWV0YWRhdGEYByADKAsyIC5nb2NhbnZhcy52MS5Cb2FyZC5NZXRhZGF0YUVudHJ5EhIKCnByb2plY3RfaWQYCCABKAwaLwoNTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBIpQBChJDcmVhdGVCb2FyZFJlcXVlc3QSDAoEbmFtZRgBIAEoCRI/CghtZXRhZGF0YRgCIAMoCzItLmdvY2FudmFzLnYxLkNyZWF0ZUJvYXJkUmVxdWVzdC5NZXRhZGF0YUVudHJ5Gi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASI4ChNDcmVhdGVCb2FyZFJlc3BvbnNlEiEKBWJvYXJkGAEgASgLMhIuZ29jYW52YXMudjEuQm9hcmQiHQoPR2V0Qm9hcmRSZXF1ZXN0EgoKAmlkGAEgASgMIjUKEEdldEJvYXJkUmVzcG9uc2USIQoFYm9hcmQYASABKAsyEi5nb2NhbnZhcy52MS5Cb2FyZCI6ChFMaXN0Qm9hcmRzUmVxdWVzdBIRCglwYWdlX3NpemUYASABKAUSEgoKcGFnZV90b2tlbhgCIAEoCSJmChJMaXN0Qm9hcmRzUmVzcG9uc2USIgoGYm9hcmRzGAEgAygLMhIuZ29jYW52YXMudjEuQm9hcmQSFwoPbmV4dF9wYWdlX3Rva2VuGAIgASgJEhMKC3RvdGFsX2NvdW50GAMgASgFIqABChJVcGRhdGVCb2FyZFJlcXVlc3QSCgoCaWQYASABKAwSDAoEbmFtZRgCIAEoCRI/CghtZXRhZGF0YRgDIAMoCzItLmdvY2FudmFzLnYxLlVwZGF0ZUJvYXJkUmVxdWVzdC5NZXRhZGF0YUVudHJ5Gi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4ASI4ChNVcGRhdGVCb2FyZFJlc3BvbnNlEiEKBWJvYXJkGAEgASgLMhIuZ29jYW52YXMudjEuQm9hcmQiIAoSRGVsZXRlQm9hcmRSZXF1ZXN0EgoKAmlkGAEgASgMIhUKE0RlbGV0ZUJvYXJkUmVzcG9uc2UivgEKBFVzZXISCgoCaWQYASABKAwSDQoFZW1haWwYAiABKAkSFAoMZGlzcGxheV9uYW1lGAMgASgJEhIKCmF2YXRhcl91cmwYBCABKAkSEQoJaXNfYWN0aXZlGAUgASgIEi4KCmNyZWF0ZWRfYXQYBiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wIhwKDkdldFVzZXJSZXF1ZXN0EgoKAmlkGAEgASgMIjIKD0dldFVzZXJSZXNwb25zZRIfCgR1c2VyGAEgASgLMhEuZ29jYW52YXMudjEuVXNlciI9ChFVcGRhdGVVc2VyUmVxdWVzdBIUCgxkaXNwbGF5X25hbWUYASABKAkSEgoKYXZhdGFyX3VybBgCIAEoCSI1ChJVcGRhdGVVc2VyUmVzcG9uc2USHwoEdXNlchgBIAEoCzIRLmdvY2FudmFzLnYxLlVzZXIiLwoMTG9naW5SZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJImQKDUxvZ2luUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhIKCnRva2VuX3R5cGUYAiABKAkSEgoKZXhwaXJlc19pbhgDIAEoBRIVCg1yZWZyZXNoX3Rva2VuGAQgASgJIkgKD1JlZ2lzdGVyUmVxdWVzdBINCgVlbWFpbBgBIAEoCRIQCghwYXNzd29yZBgCIAEoCRIUCgxkaXNwbGF5X25hbWUYAyABKAkiZwoQUmVnaXN0ZXJSZXNwb25zZRIUCgxhY2Nlc3NfdG9rZW4YASABKAkSEgoKdG9rZW5fdHlwZRgCIAEoCRISCgpleHBpcmVzX2luGAMgASgFEhUKDXJlZnJlc2hfdG9rZW4YBCABKAkiJwoOUmVmcmVzaFJlcXVlc3QSFQoNcmVmcmVzaF90b2tlbhgBIAEoCSJmCg9SZWZyZXNoUmVzcG9uc2USFAoMYWNjZXNzX3Rva2VuGAEgASgJEhIKCnRva2VuX3R5cGUYAiABKAkSEgoKZXhwaXJlc19pbhgDIAEoBRIVCg1yZWZyZXNoX3Rva2VuGAQgASgJIg8KDUxvZ291dFJlcXVlc3QiEAoOTG9nb3V0UmVzcG9uc2UipgIKB1Byb2plY3QSCgoCaWQYASABKAwSEAoIb3duZXJfaWQYAiABKAwSDQoFdGl0bGUYAyABKAkSEwoLZGVzY3JpcHRpb24YBCABKAkSEwoLaXNfcGVyc29uYWwYBSABKAgSHQoQZGVzaWduX3N5c3RlbV9pZBgGIAEoCUgAiAEBEi4KCmNyZWF0ZWRfYXQYByABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDmVmZmVjdGl2ZV9yb2xlGAkgASgOMhguZ29jYW52YXMudjEuUHJvamVjdFJvbGVCEwoRX2Rlc2lnbl9zeXN0ZW1faWQiaAoTTGlzdFByb2plY3RzUmVxdWVzdBIRCglwYWdlX3NpemUYASABKAUSEgoKcGFnZV90b2tlbhgCIAEoCRIqCgR2aWV3GAMgASgOMhwuZ29jYW52YXMudjEuUHJvamVjdExpc3RWaWV3IlcKFExpc3RQcm9qZWN0c1Jlc3BvbnNlEiYKCHByb2plY3RzGAEgAygLMhQuZ29jYW52YXMudjEuUHJvamVjdBIXCg9uZXh0X3BhZ2VfdG9rZW4YAiABKAkiIQofQm9vdHN0cmFwUGVyc29uYWxQcm9qZWN0UmVxdWVzdCJ0CiBCb290c3RyYXBQZXJzb25hbFByb2plY3RSZXNwb25zZRIlCgdwcm9qZWN0GAEgASgLMhQuZ29jYW52YXMudjEuUHJvamVjdBIpCg1zdGFydGVyX2JvYXJkGAIgASgLMhIuZ29jYW52YXMudjEuQm9hcmQiJwoRR2V0UHJvamVjdFJlcXVlc3QSEgoKcHJvamVjdF9pZBgBIAEoDCI7ChJHZXRQcm9qZWN0UmVzcG9uc2USJQoHcHJvamVjdBgBIAEoCzIULmdvY2FudmFzLnYxLlByb2plY3QiPgoUQ3JlYXRlUHJvamVjdFJlcXVlc3QSDQoFdGl0bGUYASABKAkSFwoPaWRlbXBvdGVuY3lfa2V5GAIgASgJIj4KFUNyZWF0ZVByb2plY3RSZXNwb25zZRIlCgdwcm9qZWN0GAEgASgLMhQuZ29jYW52YXMudjEuUHJvamVjdCIiChJQcm9qZWN0RXJyb3JEZXRhaWwSDAoEY29kZRgBIAEoCSqRAQoLUHJvamVjdFJvbGUSHAoYUFJPSkVDVF9ST0xFX1VOU1BFQ0lGSUVEEAASFgoSUFJPSkVDVF9ST0xFX09XTkVSEAESFwoTUFJPSkVDVF9ST0xFX0VESVRPUhACEhcKE1BST0pFQ1RfUk9MRV9WSUVXRVIQAxIaChZQUk9KRUNUX1JPTEVfQ09NTUVOVEVSEAQqegoPUHJvamVjdExpc3RWaWV3EiEKHVBST0pFQ1RfTElTVF9WSUVXX1VOU1BFQ0lGSUVEEAASHAoYUFJPSkVDVF9MSVNUX1ZJRVdfUkVDRU5UEAESJgoiUFJPSkVDVF9MSVNUX1ZJRVdfQ0FUQUxPR1VFX1NUQUJMRRACMpwDCgxCb2FyZFNlcnZpY2USUAoLQ3JlYXRlQm9hcmQSHy5nb2NhbnZhcy52MS5DcmVhdGVCb2FyZFJlcXVlc3QaIC5nb2NhbnZhcy52MS5DcmVhdGVCb2FyZFJlc3BvbnNlEkcKCEdldEJvYXJkEhwuZ29jYW52YXMudjEuR2V0Qm9hcmRSZXF1ZXN0Gh0uZ29jYW52YXMudjEuR2V0Qm9hcmRSZXNwb25zZRJNCgpMaXN0Qm9hcmRzEh4uZ29jYW52YXMudjEuTGlzdEJvYXJkc1JlcXVlc3QaHy5nb2NhbnZhcy52MS5MaXN0Qm9hcmRzUmVzcG9uc2USUAoLVXBkYXRlQm9hcmQSHy5nb2NhbnZhcy52MS5VcGRhdGVCb2FyZFJlcXVlc3QaIC5nb2NhbnZhcy52MS5VcGRhdGVCb2FyZFJlc3BvbnNlElAKC0RlbGV0ZUJvYXJkEh8uZ29jYW52YXMudjEuRGVsZXRlQm9hcmRSZXF1ZXN0GiAuZ29jYW52YXMudjEuRGVsZXRlQm9hcmRSZXNwb25zZTKiAQoLVXNlclNlcnZpY2USRAoHR2V0VXNlchIbLmdvY2FudmFzLnYxLkdldFVzZXJSZXF1ZXN0GhwuZ29jYW52YXMudjEuR2V0VXNlclJlc3BvbnNlEk0KClVwZGF0ZVVzZXISHi5nb2NhbnZhcy52MS5VcGRhdGVVc2VyUmVxdWVzdBofLmdvY2FudmFzLnYxLlVwZGF0ZVVzZXJSZXNwb25zZTKfAgoLQXV0aFNlcnZpY2USPgoFTG9naW4SGS5nb2NhbnZhcy52MS5Mb2dpblJlcXVlc3QaGi5nb2NhbnZhcy52MS5Mb2dpblJlc3BvbnNlEkcKCFJlZ2lzdGVyEhwuZ29jYW52YXMudjEuUmVnaXN0ZXJSZXF1ZXN0Gh0uZ29jYW52YXMudjEuUmVnaXN0ZXJSZXNwb25zZRJECgdSZWZyZXNoEhsuZ29jYW52YXMudjEuUmVmcmVzaFJlcXVlc3QaHC5nb2NhbnZhcy52MS5SZWZyZXNoUmVzcG9uc2USQQoGTG9nb3V0EhouZ29jYW52YXMudjEuTG9nb3V0UmVxdWVzdBobLmdvY2FudmFzLnYxLkxvZ291dFJlc3BvbnNlMo8DCg5Qcm9qZWN0U2VydmljZRJYCgxMaXN0UHJvamVjdHMSIC5nb2NhbnZhcy52MS5MaXN0UHJvamVjdHNSZXF1ZXN0GiEuZ29jYW52YXMudjEuTGlzdFByb2plY3RzUmVzcG9uc2UiA5ACARJ3ChhCb290c3RyYXBQZXJzb25hbFByb2plY3QSLC5nb2NhbnZhcy52MS5Cb290c3RyYXBQZXJzb25hbFByb2plY3RSZXF1ZXN0Gi0uZ29jYW52YXMudjEuQm9vdHN0cmFwUGVyc29uYWxQcm9qZWN0UmVzcG9uc2USUgoKR2V0UHJvamVjdBIeLmdvY2FudmFzLnYxLkdldFByb2plY3RSZXF1ZXN0Gh8uZ29jYW52YXMudjEuR2V0UHJvamVjdFJlc3BvbnNlIgOQAgESVgoNQ3JlYXRlUHJvamVjdBIhLmdvY2FudmFzLnYxLkNyZWF0ZVByb2plY3RSZXF1ZXN0GiIuZ29jYW52YXMudjEuQ3JlYXRlUHJvamVjdFJlc3BvbnNlQlJaUGdpdC5rd3JrLnRlY2gvUG9ub21hcmV2LkRlbmlzL2ZvcmstYWZmaW5lL2dvY2FudmFzL2dlbi9nby9nb2NhbnZhcy92MTtnb2NhbnZhc3YxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message gocanvas.v1.Board
 */
export type Board = Message<"gocanvas.v1.Board"> & {
  /**
   * 16-byte UUIDv7.
   *
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bytes owner_id = 3;
   */
  ownerId: Uint8Array;

  /**
   * Monotonic board-level version.
   *
   * @generated from field: int64 version = 4;
   */
  version: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * Arbitrary key/value tags.
   *
   * @generated from field: map<string, string> metadata = 7;
   */
  metadata: { [key: string]: string };

  /**
   * Owning project for project-catalogue responses.
   *
   * @generated from field: bytes project_id = 8;
   */
  projectId: Uint8Array;
};

/**
 * Describes the message gocanvas.v1.Board.
 * Use `create(BoardSchema)` to create a new message.
 */
export const BoardSchema: GenMessage<Board> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 0);

/**
 * @generated from message gocanvas.v1.CreateBoardRequest
 */
export type CreateBoardRequest = Message<"gocanvas.v1.CreateBoardRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: map<string, string> metadata = 2;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message gocanvas.v1.CreateBoardRequest.
 * Use `create(CreateBoardRequestSchema)` to create a new message.
 */
export const CreateBoardRequestSchema: GenMessage<CreateBoardRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 1);

/**
 * @generated from message gocanvas.v1.CreateBoardResponse
 */
export type CreateBoardResponse = Message<"gocanvas.v1.CreateBoardResponse"> & {
  /**
   * @generated from field: gocanvas.v1.Board board = 1;
   */
  board?: Board | undefined;
};

/**
 * Describes the message gocanvas.v1.CreateBoardResponse.
 * Use `create(CreateBoardResponseSchema)` to create a new message.
 */
export const CreateBoardResponseSchema: GenMessage<CreateBoardResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 2);

/**
 * @generated from message gocanvas.v1.GetBoardRequest
 */
export type GetBoardRequest = Message<"gocanvas.v1.GetBoardRequest"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;
};

/**
 * Describes the message gocanvas.v1.GetBoardRequest.
 * Use `create(GetBoardRequestSchema)` to create a new message.
 */
export const GetBoardRequestSchema: GenMessage<GetBoardRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 3);

/**
 * @generated from message gocanvas.v1.GetBoardResponse
 */
export type GetBoardResponse = Message<"gocanvas.v1.GetBoardResponse"> & {
  /**
   * @generated from field: gocanvas.v1.Board board = 1;
   */
  board?: Board | undefined;
};

/**
 * Describes the message gocanvas.v1.GetBoardResponse.
 * Use `create(GetBoardResponseSchema)` to create a new message.
 */
export const GetBoardResponseSchema: GenMessage<GetBoardResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 4);

/**
 * @generated from message gocanvas.v1.ListBoardsRequest
 */
export type ListBoardsRequest = Message<"gocanvas.v1.ListBoardsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 2;
   */
  pageToken: string;
};

/**
 * Describes the message gocanvas.v1.ListBoardsRequest.
 * Use `create(ListBoardsRequestSchema)` to create a new message.
 */
export const ListBoardsRequestSchema: GenMessage<ListBoardsRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 5);

/**
 * @generated from message gocanvas.v1.ListBoardsResponse
 */
export type ListBoardsResponse = Message<"gocanvas.v1.ListBoardsResponse"> & {
  /**
   * @generated from field: repeated gocanvas.v1.Board boards = 1;
   */
  boards: Board[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message gocanvas.v1.ListBoardsResponse.
 * Use `create(ListBoardsResponseSchema)` to create a new message.
 */
export const ListBoardsResponseSchema: GenMessage<ListBoardsResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 6);

/**
 * @generated from message gocanvas.v1.UpdateBoardRequest
 */
export type UpdateBoardRequest = Message<"gocanvas.v1.UpdateBoardRequest"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: map<string, string> metadata = 3;
   */
  metadata: { [key: string]: string };
};

/**
 * Describes the message gocanvas.v1.UpdateBoardRequest.
 * Use `create(UpdateBoardRequestSchema)` to create a new message.
 */
export const UpdateBoardRequestSchema: GenMessage<UpdateBoardRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 7);

/**
 * @generated from message gocanvas.v1.UpdateBoardResponse
 */
export type UpdateBoardResponse = Message<"gocanvas.v1.UpdateBoardResponse"> & {
  /**
   * @generated from field: gocanvas.v1.Board board = 1;
   */
  board?: Board | undefined;
};

/**
 * Describes the message gocanvas.v1.UpdateBoardResponse.
 * Use `create(UpdateBoardResponseSchema)` to create a new message.
 */
export const UpdateBoardResponseSchema: GenMessage<UpdateBoardResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 8);

/**
 * @generated from message gocanvas.v1.DeleteBoardRequest
 */
export type DeleteBoardRequest = Message<"gocanvas.v1.DeleteBoardRequest"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;
};

/**
 * Describes the message gocanvas.v1.DeleteBoardRequest.
 * Use `create(DeleteBoardRequestSchema)` to create a new message.
 */
export const DeleteBoardRequestSchema: GenMessage<DeleteBoardRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 9);

/**
 * @generated from message gocanvas.v1.DeleteBoardResponse
 */
export type DeleteBoardResponse = Message<"gocanvas.v1.DeleteBoardResponse"> & {
};

/**
 * Describes the message gocanvas.v1.DeleteBoardResponse.
 * Use `create(DeleteBoardResponseSchema)` to create a new message.
 */
export const DeleteBoardResponseSchema: GenMessage<DeleteBoardResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 10);

/**
 * @generated from message gocanvas.v1.User
 */
export type User = Message<"gocanvas.v1.User"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string avatar_url = 4;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool is_active = 5;
   */
  isActive: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message gocanvas.v1.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema: GenMessage<User> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 11);

/**
 * @generated from message gocanvas.v1.GetUserRequest
 */
export type GetUserRequest = Message<"gocanvas.v1.GetUserRequest"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;
};

/**
 * Describes the message gocanvas.v1.GetUserRequest.
 * Use `create(GetUserRequestSchema)` to create a new message.
 */
export const GetUserRequestSchema: GenMessage<GetUserRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 12);

/**
 * @generated from message gocanvas.v1.GetUserResponse
 */
export type GetUserResponse = Message<"gocanvas.v1.GetUserResponse"> & {
  /**
   * @generated from field: gocanvas.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gocanvas.v1.GetUserResponse.
 * Use `create(GetUserResponseSchema)` to create a new message.
 */
export const GetUserResponseSchema: GenMessage<GetUserResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 13);

/**
 * @generated from message gocanvas.v1.UpdateUserRequest
 */
export type UpdateUserRequest = Message<"gocanvas.v1.UpdateUserRequest"> & {
  /**
   * @generated from field: string display_name = 1;
   */
  displayName: string;

  /**
   * @generated from field: string avatar_url = 2;
   */
  avatarUrl: string;
};

/**
 * Describes the message gocanvas.v1.UpdateUserRequest.
 * Use `create(UpdateUserRequestSchema)` to create a new message.
 */
export const UpdateUserRequestSchema: GenMessage<UpdateUserRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 14);

/**
 * @generated from message gocanvas.v1.UpdateUserResponse
 */
export type UpdateUserResponse = Message<"gocanvas.v1.UpdateUserResponse"> & {
  /**
   * @generated from field: gocanvas.v1.User user = 1;
   */
  user?: User | undefined;
};

/**
 * Describes the message gocanvas.v1.UpdateUserResponse.
 * Use `create(UpdateUserResponseSchema)` to create a new message.
 */
export const UpdateUserResponseSchema: GenMessage<UpdateUserResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 15);

/**
 * @generated from message gocanvas.v1.LoginRequest
 */
export type LoginRequest = Message<"gocanvas.v1.LoginRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message gocanvas.v1.LoginRequest.
 * Use `create(LoginRequestSchema)` to create a new message.
 */
export const LoginRequestSchema: GenMessage<LoginRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 16);

/**
 * @generated from message gocanvas.v1.LoginResponse
 */
export type LoginResponse = Message<"gocanvas.v1.LoginResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * Always "Bearer".
   *
   * @generated from field: string token_type = 2;
   */
  tokenType: string;

  /**
   * @generated from field: int32 expires_in = 3;
   */
  expiresIn: number;

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;
};

/**
 * Describes the message gocanvas.v1.LoginResponse.
 * Use `create(LoginResponseSchema)` to create a new message.
 */
export const LoginResponseSchema: GenMessage<LoginResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 17);

/**
 * @generated from message gocanvas.v1.RegisterRequest
 */
export type RegisterRequest = Message<"gocanvas.v1.RegisterRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;
};

/**
 * Describes the message gocanvas.v1.RegisterRequest.
 * Use `create(RegisterRequestSchema)` to create a new message.
 */
export const RegisterRequestSchema: GenMessage<RegisterRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 18);

/**
 * @generated from message gocanvas.v1.RegisterResponse
 */
export type RegisterResponse = Message<"gocanvas.v1.RegisterResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string token_type = 2;
   */
  tokenType: string;

  /**
   * @generated from field: int32 expires_in = 3;
   */
  expiresIn: number;

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;
};

/**
 * Describes the message gocanvas.v1.RegisterResponse.
 * Use `create(RegisterResponseSchema)` to create a new message.
 */
export const RegisterResponseSchema: GenMessage<RegisterResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 19);

/**
 * @generated from message gocanvas.v1.RefreshRequest
 */
export type RefreshRequest = Message<"gocanvas.v1.RefreshRequest"> & {
  /**
   * @generated from field: string refresh_token = 1;
   */
  refreshToken: string;
};

/**
 * Describes the message gocanvas.v1.RefreshRequest.
 * Use `create(RefreshRequestSchema)` to create a new message.
 */
export const RefreshRequestSchema: GenMessage<RefreshRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 20);

/**
 * @generated from message gocanvas.v1.RefreshResponse
 */
export type RefreshResponse = Message<"gocanvas.v1.RefreshResponse"> & {
  /**
   * @generated from field: string access_token = 1;
   */
  accessToken: string;

  /**
   * @generated from field: string token_type = 2;
   */
  tokenType: string;

  /**
   * @generated from field: int32 expires_in = 3;
   */
  expiresIn: number;

  /**
   * @generated from field: string refresh_token = 4;
   */
  refreshToken: string;
};

/**
 * Describes the message gocanvas.v1.RefreshResponse.
 * Use `create(RefreshResponseSchema)` to create a new message.
 */
export const RefreshResponseSchema: GenMessage<RefreshResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 21);

/**
 * @generated from message gocanvas.v1.LogoutRequest
 */
export type LogoutRequest = Message<"gocanvas.v1.LogoutRequest"> & {
};

/**
 * Describes the message gocanvas.v1.LogoutRequest.
 * Use `create(LogoutRequestSchema)` to create a new message.
 */
export const LogoutRequestSchema: GenMessage<LogoutRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 22);

/**
 * @generated from message gocanvas.v1.LogoutResponse
 */
export type LogoutResponse = Message<"gocanvas.v1.LogoutResponse"> & {
};

/**
 * Describes the message gocanvas.v1.LogoutResponse.
 * Use `create(LogoutResponseSchema)` to create a new message.
 */
export const LogoutResponseSchema: GenMessage<LogoutResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 23);

/**
 * @generated from message gocanvas.v1.Project
 */
export type Project = Message<"gocanvas.v1.Project"> & {
  /**
   * @generated from field: bytes id = 1;
   */
  id: Uint8Array;

  /**
   * @generated from field: bytes owner_id = 2;
   */
  ownerId: Uint8Array;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: bool is_personal = 5;
   */
  isPersonal: boolean;

  /**
   * @generated from field: optional string design_system_id = 6;
   */
  designSystemId?: string | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 8;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: gocanvas.v1.ProjectRole effective_role = 9;
   */
  effectiveRole: ProjectRole;
};

/**
 * Describes the message gocanvas.v1.Project.
 * Use `create(ProjectSchema)` to create a new message.
 */
export const ProjectSchema: GenMessage<Project> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 24);

/**
 * @generated from message gocanvas.v1.ListProjectsRequest
 */
export type ListProjectsRequest = Message<"gocanvas.v1.ListProjectsRequest"> & {
  /**
   * 1..100.
   *
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * Opaque encrypted keyset cursor.
   *
   * @generated from field: string page_token = 2;
   */
  pageToken: string;

  /**
   * @generated from field: gocanvas.v1.ProjectListView view = 3;
   */
  view: ProjectListView;
};

/**
 * Describes the message gocanvas.v1.ListProjectsRequest.
 * Use `create(ListProjectsRequestSchema)` to create a new message.
 */
export const ListProjectsRequestSchema: GenMessage<ListProjectsRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 25);

/**
 * @generated from message gocanvas.v1.ListProjectsResponse
 */
export type ListProjectsResponse = Message<"gocanvas.v1.ListProjectsResponse"> & {
  /**
   * @generated from field: repeated gocanvas.v1.Project projects = 1;
   */
  projects: Project[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;
};

/**
 * Describes the message gocanvas.v1.ListProjectsResponse.
 * Use `create(ListProjectsResponseSchema)` to create a new message.
 */
export const ListProjectsResponseSchema: GenMessage<ListProjectsResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 26);

/**
 * @generated from message gocanvas.v1.BootstrapPersonalProjectRequest
 */
export type BootstrapPersonalProjectRequest = Message<"gocanvas.v1.BootstrapPersonalProjectRequest"> & {
};

/**
 * Describes the message gocanvas.v1.BootstrapPersonalProjectRequest.
 * Use `create(BootstrapPersonalProjectRequestSchema)` to create a new message.
 */
export const BootstrapPersonalProjectRequestSchema: GenMessage<BootstrapPersonalProjectRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 27);

/**
 * @generated from message gocanvas.v1.BootstrapPersonalProjectResponse
 */
export type BootstrapPersonalProjectResponse = Message<"gocanvas.v1.BootstrapPersonalProjectResponse"> & {
  /**
   * @generated from field: gocanvas.v1.Project project = 1;
   */
  project?: Project | undefined;

  /**
   * @generated from field: gocanvas.v1.Board starter_board = 2;
   */
  starterBoard?: Board | undefined;
};

/**
 * Describes the message gocanvas.v1.BootstrapPersonalProjectResponse.
 * Use `create(BootstrapPersonalProjectResponseSchema)` to create a new message.
 */
export const BootstrapPersonalProjectResponseSchema: GenMessage<BootstrapPersonalProjectResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 28);

/**
 * @generated from message gocanvas.v1.GetProjectRequest
 */
export type GetProjectRequest = Message<"gocanvas.v1.GetProjectRequest"> & {
  /**
   * @generated from field: bytes project_id = 1;
   */
  projectId: Uint8Array;
};

/**
 * Describes the message gocanvas.v1.GetProjectRequest.
 * Use `create(GetProjectRequestSchema)` to create a new message.
 */
export const GetProjectRequestSchema: GenMessage<GetProjectRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 29);

/**
 * @generated from message gocanvas.v1.GetProjectResponse
 */
export type GetProjectResponse = Message<"gocanvas.v1.GetProjectResponse"> & {
  /**
   * @generated from field: gocanvas.v1.Project project = 1;
   */
  project?: Project | undefined;
};

/**
 * Describes the message gocanvas.v1.GetProjectResponse.
 * Use `create(GetProjectResponseSchema)` to create a new message.
 */
export const GetProjectResponseSchema: GenMessage<GetProjectResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 30);

/**
 * @generated from message gocanvas.v1.CreateProjectRequest
 */
export type CreateProjectRequest = Message<"gocanvas.v1.CreateProjectRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string idempotency_key = 2;
   */
  idempotencyKey: string;
};

/**
 * Describes the message gocanvas.v1.CreateProjectRequest.
 * Use `create(CreateProjectRequestSchema)` to create a new message.
 */
export const CreateProjectRequestSchema: GenMessage<CreateProjectRequest> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 31);

/**
 * @generated from message gocanvas.v1.CreateProjectResponse
 */
export type CreateProjectResponse = Message<"gocanvas.v1.CreateProjectResponse"> & {
  /**
   * @generated from field: gocanvas.v1.Project project = 1;
   */
  project?: Project | undefined;
};

/**
 * Describes the message gocanvas.v1.CreateProjectResponse.
 * Use `create(CreateProjectResponseSchema)` to create a new message.
 */
export const CreateProjectResponseSchema: GenMessage<CreateProjectResponse> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 32);

/**
 * Safe machine-readable detail attached to ProjectService Connect errors.
 * It deliberately carries no internal error text or user/project PII.
 *
 * @generated from message gocanvas.v1.ProjectErrorDetail
 */
export type ProjectErrorDetail = Message<"gocanvas.v1.ProjectErrorDetail"> & {
  /**
   * @generated from field: string code = 1;
   */
  code: string;
};

/**
 * Describes the message gocanvas.v1.ProjectErrorDetail.
 * Use `create(ProjectErrorDetailSchema)` to create a new message.
 */
export const ProjectErrorDetailSchema: GenMessage<ProjectErrorDetail> = /*@__PURE__*/
  messageDesc(file_gocanvas_v1_api, 33);

/**
 * @generated from enum gocanvas.v1.ProjectRole
 */
export enum ProjectRole {
  /**
   * @generated from enum value: PROJECT_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_ROLE_OWNER = 1;
   */
  OWNER = 1,

  /**
   * @generated from enum value: PROJECT_ROLE_EDITOR = 2;
   */
  EDITOR = 2,

  /**
   * @generated from enum value: PROJECT_ROLE_VIEWER = 3;
   */
  VIEWER = 3,

  /**
   * @generated from enum value: PROJECT_ROLE_COMMENTER = 4;
   */
  COMMENTER = 4,
}

/**
 * Describes the enum gocanvas.v1.ProjectRole.
 */
export const ProjectRoleSchema: GenEnum<ProjectRole> = /*@__PURE__*/
  enumDesc(file_gocanvas_v1_api, 0);

/**
 * @generated from enum gocanvas.v1.ProjectListView
 */
export enum ProjectListView {
  /**
   * @generated from enum value: PROJECT_LIST_VIEW_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PROJECT_LIST_VIEW_RECENT = 1;
   */
  RECENT = 1,

  /**
   * @generated from enum value: PROJECT_LIST_VIEW_CATALOGUE_STABLE = 2;
   */
  CATALOGUE_STABLE = 2,
}

/**
 * Describes the enum gocanvas.v1.ProjectListView.
 */
export const ProjectListViewSchema: GenEnum<ProjectListView> = /*@__PURE__*/
  enumDesc(file_gocanvas_v1_api, 1);

/**
 * @generated from service gocanvas.v1.BoardService
 */
export const BoardService: GenService<{
  /**
   * @generated from rpc gocanvas.v1.BoardService.CreateBoard
   */
  createBoard: {
    methodKind: "unary";
    input: typeof CreateBoardRequestSchema;
    output: typeof CreateBoardResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.BoardService.GetBoard
   */
  getBoard: {
    methodKind: "unary";
    input: typeof GetBoardRequestSchema;
    output: typeof GetBoardResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.BoardService.ListBoards
   */
  listBoards: {
    methodKind: "unary";
    input: typeof ListBoardsRequestSchema;
    output: typeof ListBoardsResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.BoardService.UpdateBoard
   */
  updateBoard: {
    methodKind: "unary";
    input: typeof UpdateBoardRequestSchema;
    output: typeof UpdateBoardResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.BoardService.DeleteBoard
   */
  deleteBoard: {
    methodKind: "unary";
    input: typeof DeleteBoardRequestSchema;
    output: typeof DeleteBoardResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gocanvas_v1_api, 0);

/**
 * @generated from service gocanvas.v1.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc gocanvas.v1.UserService.GetUser
   */
  getUser: {
    methodKind: "unary";
    input: typeof GetUserRequestSchema;
    output: typeof GetUserResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.UserService.UpdateUser
   */
  updateUser: {
    methodKind: "unary";
    input: typeof UpdateUserRequestSchema;
    output: typeof UpdateUserResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gocanvas_v1_api, 1);

/**
 * @generated from service gocanvas.v1.AuthService
 */
export const AuthService: GenService<{
  /**
   * @generated from rpc gocanvas.v1.AuthService.Login
   */
  login: {
    methodKind: "unary";
    input: typeof LoginRequestSchema;
    output: typeof LoginResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.AuthService.Register
   */
  register: {
    methodKind: "unary";
    input: typeof RegisterRequestSchema;
    output: typeof RegisterResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.AuthService.Refresh
   */
  refresh: {
    methodKind: "unary";
    input: typeof RefreshRequestSchema;
    output: typeof RefreshResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.AuthService.Logout
   */
  logout: {
    methodKind: "unary";
    input: typeof LogoutRequestSchema;
    output: typeof LogoutResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gocanvas_v1_api, 2);

/**
 * @generated from service gocanvas.v1.ProjectService
 */
export const ProjectService: GenService<{
  /**
   * @generated from rpc gocanvas.v1.ProjectService.ListProjects
   */
  listProjects: {
    methodKind: "unary";
    input: typeof ListProjectsRequestSchema;
    output: typeof ListProjectsResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.ProjectService.BootstrapPersonalProject
   */
  bootstrapPersonalProject: {
    methodKind: "unary";
    input: typeof BootstrapPersonalProjectRequestSchema;
    output: typeof BootstrapPersonalProjectResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.ProjectService.GetProject
   */
  getProject: {
    methodKind: "unary";
    input: typeof GetProjectRequestSchema;
    output: typeof GetProjectResponseSchema;
  },
  /**
   * @generated from rpc gocanvas.v1.ProjectService.CreateProject
   */
  createProject: {
    methodKind: "unary";
    input: typeof CreateProjectRequestSchema;
    output: typeof CreateProjectResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gocanvas_v1_api, 3);

